module.exports = __webpack_public_path__ + "img/noTool.0199df9a.png";